import React from 'react';
import LinkBody from '@/modules/link/Layout/linkBody';

export const Link = () => {
 
  return (
    <>
      <LinkBody />
    </>
  )
}

export default Link;
